
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/subscription-clothing-box",
      function () {
        return require("private-next-pages/subscription-clothing-box/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/subscription-clothing-box"])
      });
    }
  